import React from 'react';
const SvgIdw = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <defs>
        <linearGradient x1="0%" y1="48.76%" x2="100%" y2="48.76%" id="idw_svg__b">
          <stop stopColor="#E82" offset="0%" />
          <stop stopColor="#F9CD8C" offset="98%" />
          <stop stopColor="#F9CD8C" offset="100%" />
        </linearGradient>
        <linearGradient x1=".88%" y1="49.133%" x2="100.88%" y2="49.133%" id="idw_svg__c">
          <stop stopColor="#B06E2F" offset="0%" />
          <stop stopColor="#714107" offset="84%" />
          <stop stopColor="#714107" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="49.693%" x2="165.834%" y2="49.693%" id="idw_svg__d">
          <stop stopColor="#ED8722" offset="0%" />
          <stop stopColor="#E88422" offset="16%" />
          <stop stopColor="#DA7C21" offset="34%" />
          <stop stopColor="#C26F1F" offset="54%" />
          <stop stopColor="#A15D1D" offset="75%" />
          <stop stopColor="#77461A" offset="97%" />
          <stop stopColor="#70421A" offset="100%" />
        </linearGradient>
        <linearGradient x1="55.786%" y1="47.351%" x2="47.399%" y2="-9.869%" id="idw_svg__e">
          <stop stopColor="#A75726" offset="0%" />
          <stop stopColor="#A75726" offset="8%" />
          <stop stopColor="#B36128" offset="22%" />
          <stop stopColor="#D27B2E" offset="62%" />
          <stop stopColor="#DE8530" offset="84%" />
          <stop stopColor="#DE8530" offset="100%" />
        </linearGradient>
        <linearGradient x1="65.632%" y1="-13.563%" x2="34.792%" y2="111.522%" id="idw_svg__f">
          <stop stopColor="#E82" offset="0%" />
          <stop stopColor="#F8CBA9" offset="12%" />
          <stop stopColor="#F6C397" offset="17%" />
          <stop stopColor="#F1B575" offset="26%" />
          <stop stopColor="#EEAB5C" offset="35%" />
          <stop stopColor="#ECA54D" offset="44%" />
          <stop stopColor="#EBA348" offset="50%" />
          <stop stopColor="#733C0F" offset="100%" />
        </linearGradient>
        <radialGradient
          cx="79.786%"
          cy="166.939%"
          fx="79.786%"
          fy="166.939%"
          r="331.102%"
          gradientTransform="matrix(.28727 0 0 1 .569 0)"
          id="idw_svg__a"
        >
          <stop stopColor="#6A4745" offset="0%" />
          <stop stopColor="#ED8722" offset="95%" />
          <stop stopColor="#ED8722" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#EEAD60" d="M3 31h26V8h-7V1H3z" />
        <path fill="#FFF" d="M4 2v20h24V8h-6V2z" />
        <path fill="#92571E" opacity={0.2} d="M29 15l-7-7h7z" />
        <path fill="#DE8530" d="M22 1l7 7h-7z" />
        <g>
          <path
            d="M.043 16.908V17a32.137 32.137 0 014.497-.375c1.328.028 2.651.153 3.96.375-.1-.057-1.027-2.43-3.64-2.43L.042 16.908z"
            fill="url(#idw_svg__a)"
            fillRule="nonzero"
            transform="translate(11 4)"
          />
          <path
            d="M6.106 14.57c.382.036 2.245 0 2.43 0l-.624-.481H7.02c-.298 0-.765-.46-.914-.709.165.38.165.811 0 1.19z"
            fill="url(#idw_svg__b)"
            transform="translate(11 4)"
          />
          <path
            d="M6.106 4.25a.892.892 0 01.914-.857h.552L8.5 2.43a1.665 1.665 0 00-2.415 0l.02 1.82z"
            fill="url(#idw_svg__c)"
            fillRule="nonzero"
            transform="translate(11 4)"
          />
          <path
            d="M.56 14.117l-.525.453c2.883.709 4.109-3.116 2.43-1.21a2.762 2.762 0 01-1.905.757z"
            fill="url(#idw_svg__d)"
            transform="translate(11 4)"
          />
          <path
            d="M8.5 0S5.766.354 4.25.354 0 0 0 0v2.43c.212-.008 1.169.403 1.417.403 2.443 0 4.646 11.667 4.675 11.737V4.236c0-.97.311-1.736 1.225-1.835.401-.02.803-.02 1.204 0L8.5 0z"
            fill="url(#idw_svg__e)"
            transform="translate(11 4)"
          />
          <path
            d="M7.303 14.57C4.88 14.57 4.845 2.53 1.247 2.43H.035l.709 1.012h.793c.468.029.852.38.92.843 0 0 .107 4.456 0 7.29-.032.75-.112 1.497-.24 2.238-.34.75-1.176.8-2.182.75V17a8.309 8.309 0 014.428-1.162A6.658 6.658 0 018.5 17v-2.43H7.303z"
            fill="url(#idw_svg__f)"
            transform="translate(11 4)"
          />
        </g>
        <path
          d="M10 24h.665v5H10v-5zm2.451 4.44h1.106c.075 0 .168-.006.28-.018a1.632 1.632 0 00.732-.277c.124-.083.235-.198.333-.342.098-.145.179-.326.242-.543.063-.217.094-.48.094-.788 0-.299-.03-.566-.087-.802a1.537 1.537 0 00-.288-.602 1.261 1.261 0 00-.514-.378 2.05 2.05 0 00-.778-.13h-1.12v3.88zM11.786 24H13.5c.77 0 1.364.196 1.78.588.415.392.622.99.622 1.793 0 .42-.046.792-.14 1.117a2.088 2.088 0 01-.434.82 1.882 1.882 0 01-.75.507 3.001 3.001 0 01-1.078.175h-1.715v-5zm9.446 5h-.693l-1.141-4.202h-.014L18.228 29h-.693l-1.281-5h.679l.98 4.16h.014l1.12-4.16h.722l1.106 4.16h.014L21.905 24h.665l-1.338 5z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
});
export default SvgIdw;
SvgIdw.iconName = 'idw';
SvgIdw.displayName = 'SvgIdw';
